import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';
import Swal from 'sweetalert2';

const PortalPrescriptions = ({ patientId }) => {
    const navigate = useNavigate();
    const [prescriptions, setPrescriptions] = useState([]);
    const [patientInfo, setPatientInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (patientId) {
            fetchPrescription();
        }
    }, [patientId]);

    const fetchPrescription = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`getAllPrescriptions`);
            if (response.data?.success) {

                const patientPrescriptions = response.data.data.filter(
                    (prescription) => prescription.patient_id === parseInt(patientId)
                );

                setPrescriptions(patientPrescriptions);
                if (patientPrescriptions.length > 0) {
                    setPatientInfo({
                        id: patientPrescriptions[0].patient_id,
                        name: patientPrescriptions[0].fullName,
                    });
                } else {

                    setPatientInfo({ id: patientId, name: "Patient" });
                }
            }
        }
        catch (error) {
            console.error("Error fetching prescription: ", error);
            Swal.fire("Error", "Failed to fetch prescriptions", "error");
        } finally {
            setLoading(false);
        }
    };


    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        } catch (error) {
            return "Invalid Date";
        }
    };

    if (loading) {
        return (
            <div className='pc-container'>
                <div className='pc-content'>
                    <div className='text-center p-5'>
                        <div className='spinner-border' role="status">
                            <span className='visually-hidden'>Loading...</span>

                        </div>

                    </div>

                </div>

            </div>
        )
    }
    if (!patientInfo) {
        return (
            <div className="pc-container">
                <div className="pc-content">
                    <div className="text-center p-5">
                        <h4>Patient not found</h4>
                        <button className="btn btn-primary" onClick={() => navigate(-1)}>
                            Go Back
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="pc-content">
                <div className="col-12">
                    <div className="card table-card ">
                        <div className="tableHeader">

                        </div>

                        {/* Patient Info Section */}
                        <div className="card-body p20">
                            <div className="row justify-content-center mb-4">
                                {/* <div className="col-md-3">
                                    <div className="cardBorder serviceCard h-100 p20">
                                        <div className="d-flex justify-content-between">
                                            <div className="pe-3">
                                                <h6>Patient Information</h6>
                                                <h6>
                                                    {" "}
                                                    <strong>Name: </strong>{" "}
                                                    <span>{patientInfo.name}</span>
                                                </h6>
                                            </div>
                                            <div className="avtar avtar-s bg-light-primary align-self-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect x="3" y="4" width="18" height="16" rx="2" stroke="#4680ff" stroke-width="1.8" />
                                                    <circle cx="8.5" cy="10" r="2.5" stroke="#4680ff" stroke-width="1.8" />
                                                    <path d="M5.5 16c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="#4680ff" stroke-width="1.8" stroke-linecap="round" />
                                                    <path d="M14 9h5M14 12h5" stroke="#4680ff" stroke-width="1.8" stroke-linecap="round" />
                                                </svg>


                                            </div>

                                        </div>
                                    </div>
                                </div> */}
                                <div className="col-lg-3 col-md-4">
                                    <div className="cardBorder serviceCard h-100 p20">
                                        <div className="d-flex justify-content-between">
                                            <div className="pe-3">
                                                <h6>Prescription Summary</h6>
                                                <h6>
                                                    {" "}
                                                    <strong>Last Updated: </strong>{" "}
                                                    {prescriptions.length > 0
                                                        ? formatDate(
                                                            Math.max(
                                                                ...prescriptions.map(
                                                                    (p) =>
                                                                        new Date(p.updated_at || p.created_at)
                                                                )
                                                            )
                                                        )
                                                        : "N/A"}{" "}
                                                </h6>
                                                <h6><strong>Total Prescriptions:  </strong> {prescriptions.length} </h6>
                                            </div>
                                            <div className="avtar avtar-s bg-light-success align-self-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M4 7h16v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7z" stroke="#2ca87f" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8 7a4 4 0 0 1 8 0" stroke="#2ca87f" stroke-width="1.6" stroke-linecap="round" />
                                                    <text x="12" y="17" font-size="7" font-weight="bold" text-anchor="middle" fill="#2ca87f">Rx</text>
                                                </svg>

                                            </div>

                                        </div>
                                    </div>

                                    {/* <div className="table-card">
                    
                    <div className="tableHeader">
                        <h5></h5>
                    </div>
                    <div className="p20">
                        <p className="mb-1 mr-3"><strong>Total Prescriptions:</strong> {prescriptions.length}</p>
                      <p className="mb-0"><strong>Last Updated:</strong> {
                        prescriptions.length > 0
                          ? formatDate(Math.max(...prescriptions.map(p => new Date(p.updated_at || p.created_at))))
                          : "N/A"
                      }</p>
                    </div>
                    
                    
                  </div> */}
                                </div>
                            </div>

                            {/* Prescriptions Table */}
                            {prescriptions.length > 0 ? (
                                <div className="cardBorder">
                                    <div className="table-responsive">
                                        <table className="table align-middle">
                                            <thead
                                                className="table-light"
                                                style={{ display: "table-header-group" }}
                                            >
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Medicine Name</th>
                                                    <th>Doctor</th>
                                                    <th>Strength</th>
                                                    <th>Dose</th>
                                                    <th>Frequency</th>
                                                    <th>Duration</th>
                                                    <th>Route</th>
                                                    <th>Substance</th>
                                                    <th>Notes</th>
                                                    <th>Created Date</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {prescriptions.map((prescription, index) => (
                                                    <tr key={prescription.id}>
                                                        <td>{prescription.id}</td>
                                                        <td>{prescription.medicine_name || "N/A"}</td>
                                                        <td>{prescription.doctorName || "N/A"}</td>
                                                        <td>{prescription.strength || "N/A"}</td>
                                                        <td>{prescription.dose || "N/A"}</td>
                                                        <td>{prescription.frequency || "N/A"}</td>
                                                        <td>{prescription.duration || "N/A"}</td>
                                                        <td>{prescription.route || "N/A"}</td>
                                                        <td>{prescription.substance || "N/A"}</td>
                                                        <td>
                                                            <span
                                                                title={prescription.notes || "No notes"}
                                                                style={{
                                                                    maxWidth: "150px",
                                                                    display: "inline-block",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                }}
                                                            >
                                                                {prescription.notes || "No notes"}
                                                            </span>
                                                        </td>
                                                        <td>{formatDate(prescription.created_at)}</td>
                                                        <td>
                                                            <span
                                                                className={`badge ${(prescription.status || "Plan") ===
                                                                    "Completed"
                                                                    ? "bg-success"
                                                                    : "bg-secondary"
                                                                    }`}
                                                            >
                                                                {prescription.status || "Plan"}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center p-5">
                                    <h5 className="text-muted">
                                        No prescriptions found for this patient
                                    </h5>
                                    <p className="text-muted">
                                        This patient doesn't have any prescriptions yet.
                                    </p>
                                </div>
                            )}

                            <div className="text-end mt-4">
                                {/* <button 
                  className="btn btn-secondary me-2" 
                  onClick={() => navigate(-1)}
                >
                  Go Back
                </button> */}
                                {/* <button 
                  className="btn btn-primary"
                  onClick={() => {
                    // Navigate to add new prescription for this patient
                    navigate("/Admin/AddPrescription", {
                      state: { patientId: patientInfo.id, patientName: patientInfo.name }
                    });
                  }}
                >
                  Add New Prescription
                </button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PortalPrescriptions
